import { AddressFormData } from '../types';

const initAddress: AddressFormData = {
  Title: '',
  TypeId: null,
  TypeTitle: '',
  Line1: '',
  Line2: ' ',
  City: 'Calgary',
  Province: 'AB',
  PostalCode: '',
  Country: 'Canada',
  CustomerId: null,
  PatrolType: '',
  Instructions: 'Follow regular procedures.',
  OnlineMapUrl: '',
};

export default initAddress;
